import { FC } from "react";
import { Stack } from 'react-bootstrap'
import { UploadIcon } from "../../../../svg/UploadIcon";
import { Spinner } from "react-bootstrap-v5";

interface DocumentUploadSectionProps {
    id: string,
    title: string
    description?: string
    learnMoreLink?: { href: string; text: string }
    fileTypes: string[]
    fileGroup: any[]
    handleFileUpload: (event: any, type: string, fileTypes: string[]) => void
    FileItem?: React.FC<{ file: any; id: string; removeSingleFile?: (file: any) => void }>
    supportedFormatInCommanText: string
    removeSingleFile: (file: any) => void
    downloadLink?: string
    removeAllFiles: (fileType: any) => void
    loading?: {
        type: string | null
        isLoading: boolean
    }
}

const DocumentUploadSection: FC<DocumentUploadSectionProps> = ({
    id,
    title,
    description, 
    supportedFormatInCommanText,
    learnMoreLink,
    fileTypes,
    handleFileUpload,
    fileGroup,
    FileItem,
    removeSingleFile,
    downloadLink,
    removeAllFiles,
    loading
}) => {
    return (
        <>
            <div className='cardNew no-border-card'>
                <div className='section-heading'>
                    <h2>
                        {title}
                    </h2>
                    { learnMoreLink &&
                        <a
                            className='text-primary fw-bold'
                            style={{
                                fontSize: '16px',
                                borderBottom: '1px solid currentColor',
                                cursor: 'pointer',
                                marginTop: '12px',
                                display: 'inline-block',
                                lineHeight: '1.1',
                            }}
                            href={`${learnMoreLink?.href}`}
                            target='_blank'
                            rel='noopener noreferrer'
                        >
                            {learnMoreLink?.text || 'Learn More'}
                        </a>
                    }
                    {downloadLink && (
                         <a
                        href={downloadLink}
                        download
                      >
                        <button
                          style={{ marginTop: '12px' }}
                          className='button-download-template button-outline-primary'
                        >
                          <svg
                            width='20'
                            height='20'
                            viewBox='0 0 20 20'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'
                          >
                            <g clip-path='url(#clip0_6388_6190)'>
                              <path
                                d='M3.3335 14.1666V15.8333C3.3335 16.2753 3.50909 16.6992 3.82165 17.0118C4.13421 17.3244 4.55814 17.5 5.00016 17.5H15.0002C15.4422 17.5 15.8661 17.3244 16.1787 17.0118C16.4912 16.6992 16.6668 16.2753 16.6668 15.8333V14.1666'
                                stroke='#013238'
                                stroke-width='1.66667'
                                stroke-linecap='round'
                                stroke-linejoin='round'
                              />
                              <path
                                d='M5.8335 9.16663L10.0002 13.3333L14.1668 9.16663'
                                stroke='#013238'
                                stroke-width='1.66667'
                                stroke-linecap='round'
                                stroke-linejoin='round'
                              />
                              <path
                                d='M10 3.33337V13.3334'
                                stroke='#013238'
                                stroke-width='1.66667'
                                stroke-linecap='round'
                                stroke-linejoin='round'
                              />
                            </g>
                            <defs>
                              <clipPath id='clip0_6388_6190'>
                                <rect width='20' height='20' fill='white' />
                              </clipPath>
                            </defs>
                          </svg>
                          Download & Fill Template
                        </button>
                      </a>
                    )}
                    <hr className='text-gray-400' />
                </div>

                <div
                    className='uploadBox'
                    style={{
                        border: '1px dashed var(--primary-color)',
                        padding: '63px 40px',
                        background: '#0057630A',
                        minHeight: '150px',
                        fontSize: '14px',
                        marginBottom: '15px',
                        borderRadius: '10px',
                        alignItems: 'center',
                    }}
                    onDrop={(e: React.DragEvent) => {
                        e.preventDefault()
                        e.stopPropagation()
                        const files = e.dataTransfer.files
                        if (files.length) {
                            const event = { target: { files, validity: { valid: true } } }
                            handleFileUpload(event, id, fileTypes)
                        }
                    }}
                    onDragOver={(e: React.DragEvent) => {
                        e.preventDefault()
                        e.stopPropagation()
                    }}
                    onDragLeave={(e: React.DragEvent) => {
                        e.preventDefault()
                        e.stopPropagation()
                    }}
                >{loading?.type === id && loading?.isLoading ? (
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100%",
                        }}
                    >
                        <div style={{marginBottom: "6px", fontSize: "18px"}}>Uploading file...</div>
                        <Spinner animation="border" />
                    </div>
                ) : (
                    <Stack
                        style={{
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                        gap={2}
                    >
                        <div className='upload mb-4'>
                            <input
                                id='upload-file-finance'
                                type='file'
                                multiple
                                accept={fileTypes.join(',')}
                                onChange={(e: any) =>
                                    handleFileUpload(e, id, fileTypes)
                                }
                                onDrop={(e: React.DragEvent) => {
                                    e.preventDefault()
                                    e.stopPropagation()
                                    const files = e.dataTransfer.files
                                    if (files.length) {
                                        const event = { target: { files, validity: { valid: true } } }
                                        handleFileUpload(event, id, fileTypes)
                                    }
                                }}
                                onDragOver={(e: React.DragEvent) => {
                                    e.preventDefault()
                                    e.stopPropagation()
                                }}
                                onDragLeave={(e: React.DragEvent) => {
                                    e.preventDefault()
                                    e.stopPropagation()
                                }}
                            ></input>
                            <label
                                htmlFor='upload-file-finance'
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    paddingTop: '10px',
                                }}
                            >
                                <div
                                    className='file-uploader'
                                    style={{
                                        cursor: 'pointer',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                    }}
                                >
                                    <UploadIcon color='var(--primary-color)' />

                                    <span className='dragDropTitle'>{description}</span>
                                </div>
                                <div className='file-uploader-sub'>Supported formats: {supportedFormatInCommanText}</div>
                            </label>
                        </div>
                    </Stack>
                )}
                </div>
                <div className=''>
                    <Stack
                        className='uploadedCapsules gridCapsules'
                        style={{
                            display: 'grid', 
                            gridTemplateColumns: 'repeat(2, 1fr)', 
                            gap: '12px', 
                            fontSize: '12px',
                            minWidth: '100%',
                        }}
                    >
                        {fileGroup && fileGroup.length > 0 && (
                            <>
                                {fileGroup
                                    .filter(({ type }: any) => type === id)
                                    .map(({ file, type, id }: any, i: number) => {
                                        return (
                                            FileItem && (
                                                <FileItem
                                                    key={id}
                                                    id={id}
                                                    file={file}
                                                    removeSingleFile={removeSingleFile}
                                                />
                                            )
                                        )
                                    })
                                }
                            </>
                        )}
                    </Stack>
                    {fileGroup && fileGroup.filter(({ type }: any) => type === id).length > 0 && (
                        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '16px' }}>
                            <button className='button button-primary justify-content-start' onClick={() => removeAllFiles(id)}>
                                Remove All
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </>
    )
}

export default DocumentUploadSection;